import { apiClient } from '../../axios';
import {
  GetAutoConversionPusdt,
  GetEarnBenefitResponse,
  GetEarnCurrencyOrderResponse,
  GetEarnHistoryParams,
  GetEarnHistoryResponse,
  GetEarnNudgesResponse,
  GetEarnStatisticsResponse,
  GetEarnSummaryResponse,
  GetEarnTradingBonusesResponse,
  GetMintConfirmResponse,
  GetMintExchangeRateParams,
  GetMintExchangeRateResponse,
  GetMintOverviewResponse,
  GetMintPendingResponse,
  PostAutoConversionParams,
  PostAutoConversionResponse,
  PostMintPreviewParams,
  PostMintPreviewResponse,
  type GetPremiumEarnDetailsResponse,
} from './types';

export const getEarnHistoryApi = (params: GetEarnHistoryParams) =>
  apiClient.get<GetEarnHistoryResponse>('/v1/earn/history', { params });
export const getEarnBenefitApi = () => apiClient.get<GetEarnBenefitResponse>('/v1/earn/benefit');
export const getEarnSummaryApi = () => apiClient.get<GetEarnSummaryResponse>('/v1/earn/summary');
export const getEarnStatisticsApi = () => apiClient.get<GetEarnStatisticsResponse>('/v1/earn/statistics');

/**
 * @deprecated - will be removed
 */
export const getEarnCurrencyOrderApi = () => apiClient.get<GetEarnCurrencyOrderResponse>('/v1/earn/currency/order');
/**
 * @param params.currencies - Comma-separated list of currencies to filter (e.g., "USDT,USD1,PUSDT"). If not provided, returns all currencies.
 * @deprecated - will be removed
 */
export const getEarnTradingBonusesApi = (params: { currencies?: string }) =>
  apiClient.get<GetEarnTradingBonusesResponse>('/v1/earn/benefit/trading-bonuses', { params });

export const getMintOverviewApi = (params: { currency: string }) =>
  apiClient.get<GetMintOverviewResponse>('/v1/mint/overview', { params });

export const getMintExchangeRateApi = (params: GetMintExchangeRateParams) =>
  apiClient.get<GetMintExchangeRateResponse>('/v1/mint/exchange-rate', { params });

export const postMintPreviewApi = (params: PostMintPreviewParams) =>
  apiClient.post<PostMintPreviewResponse>('/v1/mint/preview', params);

export const getMintConfirmApi = (params: { id: number }) =>
  apiClient.post<GetMintConfirmResponse>('/v1/mint/confirm', params);

export const getMintPendingApi = () => apiClient.get<GetMintPendingResponse>('/v1/mint/pending');

export const getAutoConversionPusdtApi = () => apiClient.get<GetAutoConversionPusdt>('/v1/auto-conversion/pusdt');

export const postAutoConversionPusdtApi = (params: PostAutoConversionParams) =>
  apiClient.post<PostAutoConversionResponse>('/v1/auto-conversion/pusdt', params);

export const getEarnNudgesApi = () => apiClient.get<GetEarnNudgesResponse>('/v1/earn/nudges');

export const getPremiumEarnDetailsApi = () =>
  apiClient.get<GetPremiumEarnDetailsResponse>('/v1/earn/premium-earn/details');
